import React from 'react';
import {
  Box,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Typography,
} from '@mui/material';
import NoteAddOutlined from '@mui/icons-material/NoteAddOutlined';
import LinkOutlined from '@mui/icons-material/LinkOutlined';
import {
  contextAddMenuHeaderLabelSx,
  contextAddMenuHeaderSx,
  contextAddMenuItemIconSx,
  contextAddMenuItemPrimaryTypographyProps,
  contextAddMenuItemSecondaryTypographyProps,
  contextAddMenuItemSx,
  contextAddMenuListSx,
  contextAddMenuPaperSx,
} from '../prompt-display/contextAddMenuStyles';

export default function ContextAddMenu({
  anchorEl,
  open,
  onClose,
  onCreateTemporary,
  onAttachExisting,
  anchorOrigin = { vertical: 'bottom', horizontal: 'left' },
  transformOrigin = { vertical: 'top', horizontal: 'left' },
}) {
  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      anchorOrigin={anchorOrigin}
      transformOrigin={transformOrigin}
      PaperProps={{ sx: contextAddMenuPaperSx }}
      MenuListProps={{ sx: contextAddMenuListSx }}
    >
      <Box sx={contextAddMenuHeaderSx}>
        <Typography sx={contextAddMenuHeaderLabelSx}>
          Add knowledge
        </Typography>
      </Box>
      <MenuItem
        onClick={() => {
          onClose?.();
          onCreateTemporary?.();
        }}
        sx={contextAddMenuItemSx}
      >
        <ListItemIcon sx={contextAddMenuItemIconSx}>
          <NoteAddOutlined fontSize="small" />
        </ListItemIcon>
        <ListItemText
          primary="Add session knowledge"
          secondary="Not saved to your Knowledge Library"
          primaryTypographyProps={contextAddMenuItemPrimaryTypographyProps}
          secondaryTypographyProps={contextAddMenuItemSecondaryTypographyProps}
        />
      </MenuItem>
      <MenuItem
        onClick={() => {
          onClose?.();
          onAttachExisting?.();
        }}
        sx={contextAddMenuItemSx}
      >
        <ListItemIcon sx={contextAddMenuItemIconSx}>
          <LinkOutlined fontSize="small" />
        </ListItemIcon>
        <ListItemText
          primary="Attach saved knowledge"
          secondary="Choose from your Knowledge Library"
          primaryTypographyProps={contextAddMenuItemPrimaryTypographyProps}
          secondaryTypographyProps={contextAddMenuItemSecondaryTypographyProps}
        />
      </MenuItem>
    </Menu>
  );
}
